import { SelectButtonOption } from 'ui';

export const chartDateRangeOptions: SelectButtonOption<string>[] = [
  { label: '1M', value: '1' },
  { label: '3M', value: '3' },
  { label: '6M', value: '6' },
  { label: '1Y', value: '12' },
  { label: 'ALL', value: 'all' },
];
